(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bz-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-announcement')) {
    class BzAnnouncement extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-item]')];
        this.index = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-active')));
        this.interval = Math.max(2000, Number(this.dataset.interval) || 4000);
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.paused = false;

        this.onChange = () => this.sync();
        this.onPause = () => { this.paused = true; };
        this.onResume = () => { this.paused = false; };
        this.onBlockSelect = (event) => {
          const i = this.items.indexOf(event.target.closest('[data-item]'));
          if (i > -1) { this.show(i); this.paused = true; }
        };
        this.onBlockDeselect = () => { this.paused = false; };

        this.desktop.addEventListener('change', this.onChange);
        this.addEventListener('pointerenter', this.onPause);
        this.addEventListener('pointerleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.sync();
      }

      disconnectedCallback() {
        this.stop();
        this.desktop?.removeEventListener('change', this.onChange);
      }

      sync() {
        this.stop();
        if (this.desktop.matches || this.items.length < 2) return;
        this.timer = window.setInterval(() => {
          if (this.paused || document.hidden) return;
          this.show((this.index + 1) % this.items.length);
        }, this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      show(i) {
        this.index = i;
        this.items.forEach((el, n) => el.classList.toggle('is-active', n === i));
      }
    }

    customElements.define('bz-announcement', BzAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-footer')) {
    class BzFooter extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.toggles = [...this.querySelectorAll('[data-toggle]')];

        this.onClick = (event) => {
          const toggle = event.target.closest('[data-toggle]');
          if (!toggle || !this.contains(toggle) || !this.mobile.matches) return;
          const col = toggle.closest('[data-col]');
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open));
          col?.classList.toggle('is-open', open);
        };
        this.onChange = () => this.sync();

        this.addEventListener('click', this.onClick);
        this.mobile.addEventListener('change', this.onChange);
        this.sync();

        // After a newsletter submit, bring the result into view for keyboard and screen reader users
        const success = this.querySelector('.bz-footer__msg--success');
        if (success && window.location.hash.includes('contact_form')) success.focus({ preventScroll: false });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.mobile?.removeEventListener('change', this.onChange);
      }

      /* Phones: headings are accordion buttons. Wider screens: plain headings, lists always visible. */
      sync() {
        const isMobile = this.mobile.matches;
        this.toggles.forEach((toggle) => {
          const col = toggle.closest('[data-col]');
          toggle.disabled = !isMobile;
          if (isMobile) {
            toggle.setAttribute('aria-expanded', String(col?.classList.contains('is-open') || false));
          } else {
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      }
    }

    customElements.define('bz-footer', BzFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-main-collection"]) return;
  try {
    
  (function () {
    if (customElements.get('bz-collection')) return;

    var KEY_D = 'bz-coll-cols-d';
    var KEY_M = 'bz-coll-cols-m';
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    class BzCollection extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.classList.add('bz-js');
        this.sectionId = this.dataset.sectionId;
        this.mqDesktop = window.matchMedia('(min-width: 750px)');
        this.currentKey = location.pathname + location.search;

        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.onMqChange = this.onMqChange.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onDocClick);
        window.addEventListener('popstate', this.onPopState);
        if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', this.onMqChange);

        this.applyView();
      }

      disconnectedCallback() {
        this._ready = false;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('popstate', this.onPopState);
        if (this.mqDesktop && this.mqDesktop.removeEventListener) this.mqDesktop.removeEventListener('change', this.onMqChange);
        if (this.abort) this.abort.abort();
        this.unlockScroll();
      }

      /* ---------- getters ---------- */
      get inner() { return this.querySelector('[data-bz-inner]'); }
      get drawer() { return this.querySelector('[data-bz-drawer]'); }
      get overlay() { return this.querySelector('[data-bz-overlay]'); }
      get form() { return this.querySelector('[data-bz-form]'); }
      get isDesktop() { return this.mqDesktop.matches; }
      get drawerOpen() { var d = this.drawer; return !!(d && d.classList.contains('is-open')); }

      /* ---------- view toggle ---------- */
      applyView() {
        var d = null;
        var m = null;
        try {
          d = localStorage.getItem(KEY_D);
          m = localStorage.getItem(KEY_M);
        } catch (e) {}
        if (d === '4' || d === '6') this.setAttribute('data-cols-d', d);
        if (m === '1' || m === '2') this.setAttribute('data-cols-m', m);
        this.syncViewButtons();
      }

      syncViewButtons() {
        var colsD = this.getAttribute('data-cols-d') || '4';
        var colsM = this.getAttribute('data-cols-m') || '2';
        this.querySelectorAll('[data-bz-view]').forEach(function (btn) {
          var parts = btn.getAttribute('data-bz-view').split(':');
          var on = parts[0] === 'd' ? parts[1] === colsD : parts[1] === colsM;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      setView(token) {
        var parts = token.split(':');
        var desktop = parts[0] === 'd';
        this.setAttribute(desktop ? 'data-cols-d' : 'data-cols-m', parts[1]);
        try { localStorage.setItem(desktop ? KEY_D : KEY_M, parts[1]); } catch (e) {}
        this.syncViewButtons();
      }

      /* ---------- events ---------- */
      onClick(event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var viewBtn = target.closest('[data-bz-view]');
        if (viewBtn && this.contains(viewBtn)) {
          this.setView(viewBtn.getAttribute('data-bz-view'));
          return;
        }

        if (target.closest('[data-bz-drawer-open]')) { this.openDrawer(); return; }
        if (target.closest('[data-bz-drawer-close]')) { this.closeDrawer(true); return; }
        if (target.closest('[data-bz-sort-close]')) { this.closeSort(true); return; }
        if (target.closest('[data-bz-overlay]')) {
          if (this.drawerOpen) this.closeDrawer(true);
          this.closeSort(false);
          return;
        }

        var link = target.closest('a[data-bz-ajax]');
        if (!link || !this.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();

        var url;
        if (link.hasAttribute('data-bz-sort-value')) {
          url = new URL(location.href);
          url.searchParams.delete('page');
          var value = link.getAttribute('data-bz-sort-value');
          if (value === this.dataset.defaultSort) url.searchParams.delete('sort_by');
          else url.searchParams.set('sort_by', value);
        } else {
          url = new URL(link.href, location.href);
        }
        this.navigate(url, { scroll: link.hasAttribute('data-bz-scroll') });
      }

      onChange(event) {
        var form = this.form;
        var target = event.target;
        if (!form || !(target instanceof HTMLInputElement) || target.form !== form) return;
        this.navigate(this.formUrl(form));
      }

      onSubmit(event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-bz-form]')) return;
        event.preventDefault();
        this.navigate(this.formUrl(form));
        if (this.drawerOpen) this.closeDrawer(true);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          var openDd = this.openDropdowns().filter(function (dd) { return this.isDesktop || dd.hasAttribute('data-bz-sort'); }, this);
          if (openDd.length) {
            event.preventDefault();
            openDd.forEach(function (dd) { dd.removeAttribute('open'); });
            var summary = openDd[0].querySelector('summary');
            if (summary) summary.focus();
            return;
          }
          if (this.drawerOpen) {
            event.preventDefault();
            this.closeDrawer(true);
          }
          return;
        }

        if (event.key === 'Tab' && !this.isDesktop) {
          var scope = null;
          if (this.drawerOpen) scope = this.drawer;
          else {
            var sort = this.querySelector('details[data-bz-sort][open]');
            if (sort) scope = sort;
          }
          if (scope) this.trapFocus(event, scope);
        }
      }

      trapFocus(event, scope) {
        var items = Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      onToggle(event) {
        var dd = event.target;
        if (!(dd instanceof HTMLElement) || !dd.matches('details[data-bz-dd]')) return;

        if (dd.open && this.isDesktop) {
          this.openDropdowns().forEach(function (other) {
            if (other !== dd) other.removeAttribute('open');
          });
        }

        if (dd.hasAttribute('data-bz-sort') && !this.isDesktop) {
          if (dd.open) {
            this.showOverlay();
            var current = dd.querySelector('.bz-coll__sort-opt.is-current') || dd.querySelector('.bz-coll__sort-opt');
            if (current) current.focus({ preventScroll: true });
          } else if (!this.drawerOpen) {
            this.hideOverlay();
          }
        }
      }

      onFocusOut(event) {
        if (!this.isDesktop) return;
        var next = event.relatedTarget;
        if (!(next instanceof Element)) return;
        this.openDropdowns().forEach(function (dd) {
          if (!dd.contains(next)) dd.removeAttribute('open');
        });
      }

      onDocClick(event) {
        if (!this.isDesktop) return;
        var target = event.target;
        this.openDropdowns().forEach(function (dd) {
          if (!(target instanceof Node) || !dd.contains(target)) dd.removeAttribute('open');
        });
      }

      onPopState() {
        var key = location.pathname + location.search;
        if (key === this.currentKey) return;
        this.navigate(new URL(location.href), { push: false });
      }

      onMqChange() {
        if (this.isDesktop) {
          if (this.drawerOpen) this.closeDrawer(false);
          this.hideOverlay();
        } else {
          this.openDropdowns().forEach(function (dd) { dd.removeAttribute('open'); });
        }
      }

      openDropdowns() {
        return Array.prototype.slice.call(this.querySelectorAll('details[data-bz-dd][open]'));
      }

      /* ---------- drawer / sheet ---------- */
      showOverlay() {
        var o = this.overlay;
        if (o) o.hidden = false;
        document.documentElement.setAttribute('scroll-lock', '');
        this._locked = true;
      }

      hideOverlay() {
        var o = this.overlay;
        if (o) o.hidden = true;
        this.unlockScroll();
      }

      unlockScroll() {
        if (!this._locked) return;
        this._locked = false;
        document.documentElement.removeAttribute('scroll-lock');
      }

      markDrawerOpen(drawer) {
        drawer.classList.add('is-open');
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-label', drawer.getAttribute('data-label') || 'Filters');
        var opener = this.querySelector('[data-bz-drawer-open]');
        if (opener) opener.setAttribute('aria-expanded', 'true');
      }

      openDrawer() {
        var drawer = this.drawer;
        if (!drawer) return;
        this.markDrawerOpen(drawer);
        this.showOverlay();
        var close = drawer.querySelector('[data-bz-drawer-close]');
        if (close) close.focus({ preventScroll: true });
      }

      closeDrawer(returnFocus) {
        var drawer = this.drawer;
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        drawer.removeAttribute('aria-label');
        this.hideOverlay();
        var opener = this.querySelector('[data-bz-drawer-open]');
        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
          if (returnFocus) opener.focus({ preventScroll: true });
        }
      }

      closeSort(returnFocus) {
        var sort = this.querySelector('details[data-bz-sort][open]');
        if (!sort) return;
        sort.removeAttribute('open');
        if (!this.drawerOpen) this.hideOverlay();
        if (returnFocus) {
          var summary = sort.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        }
      }

      /* ---------- navigation (Section Rendering API) ---------- */
      formUrl(form) {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
          if (typeof value !== 'string' || value === '') return;
          params.append(key, value);
        });
        if (params.get('sort_by') === this.dataset.defaultSort) params.delete('sort_by');
        var url = new URL(form.getAttribute('action') || location.pathname, location.href);
        url.search = params.toString();
        return url;
      }

      captureState() {
        var inner = this.inner;
        var active = document.activeElement;
        var body = this.querySelector('[data-bz-drawer-body]');
        return {
          drawerOpen: this.drawerOpen,
          drawerScroll: body ? body.scrollTop : 0,
          openIds: Array.prototype.map.call(this.querySelectorAll('details.bz-coll__dd--filter[open]'), function (dd) { return dd.id; }),
          activeId: active && inner && inner.contains(active) ? active.id : '',
          hadFocus: !!(active && inner && inner.contains(active)),
        };
      }

      restoreState(state, options) {
        state.openIds.forEach(function (id) {
          var dd = document.getElementById(id);
          if (dd && this.contains(dd)) dd.setAttribute('open', '');
        }, this);

        if (state.drawerOpen && !this.isDesktop && this.drawer) {
          this.markDrawerOpen(this.drawer);
          var body = this.querySelector('[data-bz-drawer-body]');
          if (body) body.scrollTop = state.drawerScroll;
        } else if (state.drawerOpen || !this.isDesktop) {
          this.hideOverlay();
        }

        this.syncViewButtons();

        var results = this.querySelector('[data-bz-results]');
        var focusTarget = null;
        if (!options.scroll && state.activeId) {
          var same = document.getElementById(state.activeId);
          if (same && this.contains(same) && same.offsetParent !== null) focusTarget = same;
        }
        if (!focusTarget && state.hadFocus) {
          if (this.drawerOpen) focusTarget = this.querySelector('[data-bz-drawer-close]');
          else focusTarget = results;
        }
        if (focusTarget) focusTarget.focus({ preventScroll: true });

        if (options.scroll) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }

        var status = this.querySelector('[data-bz-status]');
        var count = this.querySelector('[data-bz-count]');
        var empty = this.querySelector('.bz-coll__empty-text');
        if (status) status.textContent = count ? count.textContent : empty ? empty.textContent : '';
      }

      async navigate(url, options) {
        options = options || {};
        var push = options.push !== false;
        var target = new URL(url, location.href);
        target.searchParams.delete('section_id');
        var key = target.pathname + target.search;
        if (push && key === this.currentKey) return;

        if (this.abort) this.abort.abort();
        var controller = new AbortController();
        this.abort = controller;
        this.setAttribute('aria-busy', 'true');

        var fetchUrl = new URL(target.href);
        fetchUrl.searchParams.set('section_id', this.sectionId);

        try {
          var response = await fetch(fetchUrl.href, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          var html = await response.text();
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bz-inner]');
          if (!fresh) throw new Error('Section markup not found');

          var state = this.captureState();
          this.inner.innerHTML = fresh.innerHTML;
          this.currentKey = key;
          if (push) history.pushState({ bzCollection: true }, '', key + target.hash);
          this.restoreState(state, options);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          window.location.assign(target.href);
          return;
        } finally {
          if (this.abort === controller) {
            this.abort = null;
            this.removeAttribute('aria-busy');
          }
        }
      }
    }

    customElements.define('bz-collection', BzCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-mobile-nav')) {
    class BzMobileNav extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.progress = this.querySelector('[data-progress]');
        this.bar = this.querySelector('[data-progress-bar]');
        if (!this.track || !this.progress || !this.bar) return;

        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        // Bring the current page's link into view without moving the page
        const current = this.track.querySelector('[aria-current="page"]');
        if (current) {
          const left = current.offsetLeft - (this.track.clientWidth - current.offsetWidth) / 2;
          this.track.scrollLeft = Math.max(0, left);
        }

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      update() {
        const { scrollWidth, clientWidth, scrollLeft } = this.track;
        const overflow = scrollWidth - clientWidth;

        if (clientWidth === 0) return;

        if (overflow <= 1) {
          this.progress.hidden = true;
          return;
        }

        this.progress.hidden = false;
        const ratio = clientWidth / scrollWidth;
        const barWidth = this.progress.clientWidth * ratio;
        const travel = this.progress.clientWidth - barWidth;
        const position = Math.min(1, Math.max(0, scrollLeft / overflow));

        this.bar.style.width = `${barWidth}px`;
        this.bar.style.transform = `translateX(${travel * position}px)`;
      }
    }

    customElements.define('bz-mobile-nav', BzMobileNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bz-popup')) return;

    const KEY = 'bz-popup';
    const SUBMIT_FLAG = 'bz-popup:submitted';
    const TAB_FLAG = 'bz-popup:tab-closed';
    const DAY = 86400000;
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const store = {
      read() {
        try {
          const value = JSON.parse(window.localStorage.getItem(KEY) || '{}');
          return value && typeof value === 'object' ? value : {};
        } catch (error) {
          return {};
        }
      },
      write(patch) {
        try {
          window.localStorage.setItem(KEY, JSON.stringify(Object.assign(store.read(), patch)));
        } catch (error) { /* private mode: state just lasts for this page view */ }
      },
      session(key, value) {
        try {
          if (value === undefined) return window.sessionStorage.getItem(key);
          if (value === null) window.sessionStorage.removeItem(key);
          else window.sessionStorage.setItem(key, value);
        } catch (error) { /* ignore */ }
        return null;
      },
    };

    class BzPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-dialog]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.card = this.querySelector('[data-card]');
        this.tab = this.querySelector('[data-tab]');
        this.form = this.querySelector('form');
        this.sectionId = this.dataset.sectionId || '';
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.days = Math.max(0, parseFloat(this.dataset.days) || 0);
        this.delay = Math.max(0, parseFloat(this.dataset.delay) || 0) * 1000;
        this.memory = {};
        this.retries = 0;

        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.dialog.addEventListener('mousedown', (event) => { this.pressedOverlay = event.target === this.dialog; }, { signal });
        this.dialog.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.dialog.addEventListener('close', () => this.onClose(), { signal });
        this.form?.addEventListener('submit', () => this.onSubmit(), { signal });
        this.querySelector('[data-email]')?.addEventListener('input', (event) => {
          event.target.removeAttribute('aria-invalid');
          const message = this.querySelector('[data-error]');
          if (message) message.hidden = true;
        }, { signal });

        if (this.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail?.sectionId !== this.sectionId) return;
            window.__bzPopupSelected = this.sectionId;
            this.open({ state: this.editorState, instant: true });
          }, { signal });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.detail?.sectionId !== this.sectionId) return;
            window.__bzPopupSelected = null;
            this.close();
          }, { signal });
          this.updateTab();
          if (window.__bzPopupSelected === this.sectionId) this.open({ state: this.editorState, instant: true });
          return;
        }

        this.start();
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.timer);
        clearTimeout(this.copyTimer);
        this.releasePadding();
      }

      get editorState() {
        return this.dataset.editorSuccess === 'true' ? 'success' : 'form';
      }

      get state() {
        return Object.assign({}, store.read(), this.memory);
      }

      remember(patch) {
        Object.assign(this.memory, patch);
        store.write(patch);
      }

      within(timestamp) {
        return Boolean(timestamp) && this.days > 0 && Date.now() - Number(timestamp) < this.days * DAY;
      }

      /* ---- page load ---- */
      start() {
        const formId = this.dataset.formId;
        const url = new URL(window.location.href);
        const mine = decodeURIComponent(url.hash) === `#${formId}` || store.session(SUBMIT_FLAG) === '1';
        store.session(SUBMIT_FLAG, null);

        const posted = this.querySelector('[data-posted]')?.dataset.posted === 'true' || url.searchParams.get('customer_posted') === 'true';
        const failed = Boolean(this.querySelector('[data-error]'));

        if (mine && posted) {
          this.remember({ subscribed: Date.now() });
          this.open({ state: 'success' });
          this.cleanUrl(url);
          this.updateTab();
          return;
        }

        if (mine && failed) {
          this.open({ state: 'form', focus: '[data-email]' });
          return;
        }

        this.updateTab();
        if (this.dataset.enabled !== 'true' || this.dataset.auto !== 'true' || this.dataset.member === 'true') return;
        const state = this.state;
        if (state.subscribed || this.within(state.closedAt)) return;
        this.timer = window.setTimeout(() => this.tryAutoOpen(), this.delay);
      }

      cleanUrl(url) {
        try {
          url.searchParams.delete('customer_posted');
          url.hash = '';
          window.history.replaceState(window.history.state, '', url.pathname + url.search);
        } catch (error) { /* ignore */ }
      }

      /** Something else owns the screen (cart drawer, search, menu drawer, filters) or the visitor is typing. */
      busy() {
        if (document.hidden) return true;
        if (document.querySelector('dialog[open], [aria-modal="true"][open], details.menu-drawer-container[open]')) return true;
        if (document.documentElement.hasAttribute('scroll-lock') || document.body.style.position === 'fixed') return true;
        const active = document.activeElement;
        return Boolean(active && active.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]'));
      }

      tryAutoOpen() {
        if (this.dialog.open || this.state.subscribed) return;
        if (this.busy()) {
          this.retries += 1;
          if (this.retries <= 60) this.timer = window.setTimeout(() => this.tryAutoOpen(), 2000);
          return;
        }
        this.open({ state: 'form', auto: true });
      }

      /* ---- open / close ---- */
      setState(state) {
        this.dataset.state = state;
        this.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== state;
        });
        const heading = this.querySelector(`[data-panel="${state}"] h2[id]`);
        if (heading) this.dialog.setAttribute('aria-labelledby', heading.id);
      }

      open({ state = 'form', opener = null, focus = null, instant = false } = {}) {
        this.setState(state);
        if (this.dialog.open) return;
        clearTimeout(this.timer);
        this.opener = opener || (document.activeElement !== document.body ? document.activeElement : null);
        this.dialog.toggleAttribute('data-instant', instant);

        // keep the layout from jumping when the scrollbar disappears (the lock itself is CSS-only)
        const root = document.documentElement;
        const gap = window.innerWidth - root.clientWidth;
        if (gap > 0) {
          this.prevPadding = root.style.paddingRight;
          root.style.paddingRight = `${gap}px`;
          this.padded = true;
        }

        if (this.tab) this.tab.hidden = true;
        this.dialog.showModal();
        this.dialog.scrollTop = 0;

        const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        let target = focus ? this.querySelector(focus) : null;
        if (!target && state === 'form' && finePointer && !this.designMode) target = this.querySelector('[data-panel="form"] input:not([type="hidden"])');
        if (!target && state === 'success') target = this.querySelector('[data-copy]') || this.querySelector('[data-shop]');
        (target || this.card)?.focus({ preventScroll: true });
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      releasePadding() {
        if (!this.padded) return;
        document.documentElement.style.paddingRight = this.prevPadding || '';
        this.padded = false;
      }

      /** Runs for every way of closing: X, overlay, Escape, "No thanks", editor deselect. */
      onClose() {
        this.releasePadding();
        if (!this.designMode && this.dataset.state === 'form') this.remember({ closedAt: Date.now() });
        this.updateTab();

        const opener = this.opener;
        this.opener = null;
        const target = opener && opener.isConnected && opener.offsetParent !== null ? opener : this.querySelector('[data-tab]:not([hidden]) [data-tab-open]');
        target?.focus({ preventScroll: true });
      }

      updateTab() {
        if (!this.tab) return;
        if (this.designMode) {
          this.tab.hidden = this.dialog.open;
          return;
        }
        const state = this.state;
        const dismissed = store.session(TAB_FLAG) === '1' || this.memory.tabClosed || this.within(state.tabClosedAt);
        const show = this.dataset.tab === 'true'
          && this.dataset.member !== 'true'
          && !state.subscribed
          && Boolean(state.closedAt)
          && !dismissed
          && !this.dialog.open;
        this.tab.hidden = !show;
      }

      /* ---- events ---- */
      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target === this.dialog) {
          if (this.pressedOverlay) this.close();
          this.pressedOverlay = false;
          return;
        }
        if (target.closest('[data-close]')) return this.close();
        if (target.closest('[data-copy]')) return this.copy(target.closest('[data-copy]'));
        if (target.closest('[data-code]')) return target.closest('[data-code]').select();

        const tabOpen = target.closest('[data-tab-open]');
        if (tabOpen) return this.open({ state: 'form', opener: tabOpen });

        if (target.closest('[data-tab-close]')) {
          this.memory.tabClosed = true;
          store.session(TAB_FLAG, '1');
          this.remember({ tabClosedAt: Date.now() });
          this.updateTab();
        }
      }

      onKeydown(event) {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
        if (!items.length) {
          event.preventDefault();
          return;
        }
        const first = items[0];
        const last = items[items.length - 1];
        const active = document.activeElement;
        if (event.shiftKey && (active === first || active === this.card || !this.dialog.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || !this.dialog.contains(active))) {
          event.preventDefault();
          first.focus();
        }
      }

      onSubmit() {
        // native validation already passed (required + type=email); Shopify reloads the page after this
        store.session(SUBMIT_FLAG, '1');
        const button = this.querySelector('[data-submit]');
        if (button) {
          button.setAttribute('aria-busy', 'true');
          window.setTimeout(() => { button.disabled = true; }, 0);
        }
      }

      async copy(button) {
        const field = this.querySelector('[data-code]');
        const code = field ? field.value : '';
        if (!code) return;
        let copied = false;
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          try {
            field.focus({ preventScroll: true });
            field.select();
            field.setSelectionRange(0, code.length);
            copied = document.execCommand('copy');
          } catch (fallbackError) {
            copied = false;
          }
        }
        if (!copied) {
          // last resort: leave the code selected so the visitor can copy it by hand
          field.focus({ preventScroll: true });
          field.select();
        }
        const label = copied ? button.dataset.copied : button.dataset.manual;
        button.textContent = label || button.dataset.label;
        const status = this.querySelector('[data-copy-status]');
        if (status) status.textContent = label || '';
        clearTimeout(this.copyTimer);
        this.copyTimer = window.setTimeout(() => {
          button.textContent = button.dataset.label;
          if (status) status.textContent = '';
        }, 2500);
      }
    }

    customElements.define('bz-popup', BzPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-product-row"] && !Shopify.designMode) return;
  try {
    
  class BzProductRow extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.recsUrl || this.loaded) return;
      this.loaded = true;
      this.load();
    }

    async load() {
      const params = new URLSearchParams({
        product_id: this.dataset.productId,
        limit: this.dataset.limit || '10',
        section_id: this.dataset.sectionId,
      });
      if (this.dataset.intent) params.set('intent', this.dataset.intent);

      try {
        const response = await fetch(`${this.dataset.recsUrl}?${params}`);
        if (!response.ok) throw new Error(`Recommendations ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = html.querySelector('bz-product-row [data-track]');
        const track = this.querySelector('[data-track]');
        if (!incoming || !track || !incoming.children.length) return; // no results: stay hidden
        this.hidden = false;
        track.innerHTML = incoming.innerHTML;
      } catch (error) {
        console.warn('[bz-product-row]', error);
      }
    }
  }
  customElements.get('bz-product-row') || customElements.define('bz-product-row', BzProductRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bz-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class BzProductTabs extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('.bz-ptabs__panel')];
      if (!this.tablist) return;

      this.tablist.addEventListener('click', (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
        if (tab) this.select(this.tabs.indexOf(tab));
      }, { signal });

      this.tablist.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current < 0) return;
        let next = -1;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        this.select(next, true);
      }, { signal });

      // theme editor: selecting a tab block shows that tab
      document.addEventListener('shopify:block:select', (event) => {
        const tab = event.target instanceof Element && this.contains(event.target) ? event.target.closest('[role="tab"]') : null;
        if (tab) this.select(this.tabs.indexOf(tab));
      }, { signal });
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    select(index, focus = false) {
      if (index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) tab.removeAttribute('tabindex');
        else tab.setAttribute('tabindex', '-1');
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      const tab = this.tabs[index];
      if (focus) tab.focus({ preventScroll: true });
      // keep the active pill visible inside the scrolling row (without moving the page)
      const list = this.tablist;
      const left = tab.offsetLeft - list.offsetLeft;
      if (left < list.scrollLeft) list.scrollTo({ left: left - 16, behavior: 'smooth' });
      else if (left + tab.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollTo({ left: left + tab.offsetWidth - list.clientWidth + 16, behavior: 'smooth' });

      this.panels[index]?.querySelector('bz-carousel')?.refresh?.();
    }
  }
  customElements.get('bz-product-tabs') || customElements.define('bz-product-tabs', BzProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
